const initialState = {
    data: null,
};
const getBalanceRedux = (state = initialState, action) => {
    switch (action.type) {
        case 'GETBALANCE_SUCCESS':
            return {
                ...state,
                data: action.payload,
            };
        case 'GETBALANCE_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        default:
            return state;
    }
}

export default getBalanceRedux;